import AudioPlayer from "./audio";
import style from "./style.module.scss"
import { Link } from "react-router-dom";
import play1 from "../../assets/icons/listen_w.svg"
import play2 from "../../assets/icons/listen.svg"
import read1 from "../../assets/icons/read_w.svg"
import read2 from "../../assets/icons/read.svg"
import { ReactNode, useState } from "react";
import { getGameRoute } from "../../routes";
import MoreInfo from "../moreInfo";
type Props = {
    links: {
        link1: string,
        link2?: string,
        link3?: string
    }
    answers: {
        ans1: string,
        ans2?: string,
        ans3?: string
    }
    question: string,
    audio: string,
    title: string,
    content: ReactNode
}
export default function MainLayout({ links, answers, audio, title, question, content }: Props) {
    const [showBlue, setShowBlue] = useState(false);
    const [showContent, setShowContent] = useState(false);
    return (
        <div className={style.mainLayout}>
            <MoreInfo />
            <div className={style.content}>
                <nav>
                    <h1>{title}</h1>
                    <button>
                        {showBlue &&
                            <img src={play1} className={style.white} alt="" onClick={() => {setShowBlue(!showBlue); setShowContent(false)}} />
                        }
                        {!showBlue &&
                            <img src={play2} alt="" onClick={() => {setShowBlue(!showBlue); setShowContent(true)}} />
                        }
                        {!showBlue &&
                            <img src={read1} className={style.white} alt="" onClick={() => {setShowBlue(!showBlue); setShowContent(true)}} />
                        }
                        {showBlue &&
                            <img src={read2} alt="" onClick={() => {setShowBlue(!showBlue); setShowContent(false)}} />
                        }
                    </button>
                </nav>
                <AudioPlayer audioSrc={audio} />
                <div className={style.text}>{showContent && content}</div>
                <h2>{question}</h2>
                <div className={style.buttons}>
                    <Link to={getGameRoute(links.link1)}>{answers.ans1}</Link>
                    {links.link2 && <Link to={getGameRoute(links.link2)} className={style.buttonBlue}>{answers.ans2}</Link>}
                    {links.link3 && <Link to={getGameRoute(links.link3)}>{answers.ans3}</Link>}
                </div>
                
            </div>
        </div>
    )
}